module.exports = __webpack_public_path__ + "static/media/kopila_sad_girl.1758a550.gif";